import api from "./api";
import { absoluteLogoUrl } from "./agencyLogo";

/**
 * Dados públicos de um hotel (página /hotel/:token). Endpoint público (sem JWT):
 *   GET /api/v1/public/hotel/:token  (+ ?a=<agencyToken> p/ branding).
 * O token é opaco (o backend resolve o fornecedor — nunca vem origin/property_id).
 * `agencia.logoUrl` é relativo → prefixamos com o host da API.
 * Erros: 400 INVALID_TOKEN, 404 NOT_FOUND (axios rejeita → a página mostra "não encontrado").
 */
export const getPublicHotel = async (token, a) => {
	const data = await api
		.get(`/api/v1/public/hotel/${token}`, { params: a ? { a } : undefined })
		.then((r) => r.data);
	if (data && data.agencia && data.agencia.logoUrl) {
		data.agencia = { ...data.agencia, logoUrl: absoluteLogoUrl(data.agencia.logoUrl) };
	}
	return data;
};

export default getPublicHotel;
